/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxcTradeV1TradeEvent } from '@interxfi/types';
import { schema } from 'normalizr';

export const IXC_TRADE_V1_TRADE_EVENT_ENTITY_NAME = 'ixc.trade.v1.TradeEvent';
export const ixcTradeV1TradeEventEntity = new schema.Entity<IxcTradeV1TradeEvent>(IXC_TRADE_V1_TRADE_EVENT_ENTITY_NAME, {}, { idAttribute: (entity: IxcTradeV1TradeEvent) => `${entity.metadata?.eventId}` });

